/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit, isDevMode } from '@angular/core';
import {Http, Response, RequestOptions,Headers} from '@angular/http';
import 'rxjs/add/operator/map';
import { PagesComponent } from './pages/pages.component';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})

export class AppComponent{

  public apiUrl= '';
  public headers : Headers;
  public options : RequestOptions;
  isLoaded = false;

  constructor(private http: Http,
    private navegacion: PagesComponent) {
    this.headers = new Headers({'Content-Type': 'application/x-www-form-urlencoded'});
    this.options = new RequestOptions({headers : this.headers});

    

    if(isDevMode()){
      console.log("IS DEV MODE");
      //-dev
       this.apiUrl =  './';
      // this.apiUrl = 'http://localhost/terralta-php/';
    }
   else{
      console.log("IS PROD MODE");
      //-prod
      this.apiUrl = 'http://69.175.104.98/~wmjbcnug/terralta/';
    }
  }
  ngAfterViewInit() { 
    this.navegacion.menu1.subscribe(res => this.isLoaded = res);
      var menu1 = this.navegacion.loadMenu(this.isLoaded);
   }

}